import { atom } from 'recoil'

export const pageState = atom({
  key: 'messageEditPageState',
  default: {
    loading: false,
    title: undefined
  }
})

export const pageErrorState = atom({
  key: 'messageEditPageErrorState',
  default: {
    error: undefined,
    severity: 'danger'
  }
})
